import { useNavigate } from "react-router-dom";
import React from "react";
import { MoveLeft } from "lucide-react";
import styles from "../teams/components/TeamSettings.module.css";
import "../join-team/JoinWithCode.css";
import { useLoginPage } from "../login/useLoginPage";
import LoginCodeInput from "../authentication/components/LoginCodeInput";

const SUBSCRIPTION_SITE = "https://www.experienceapp.io/premium";

const TeamDemoUpgrade = () => {
  const navigate = useNavigate();
  const {
    error,
    emailForMagic,
    isLoading,
    successMessage,
    showCodeInput,
    setEmailForMagic,
    sendMagicLink,
    handleCodeVerified,
    handleBackToEmail,
    isOnline,
    loadingStates,
  } = useLoginPage();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <div className="settings-element-header">
        <MoveLeft
          onClick={() =>
            showCodeInput
              ? handleBackToEmail()
              : navigate("/app/demo-team/next")
          }
          className={styles["back-button"]}
          aria-label="Back"
        />
        <p className={`settings-element-title page-title`}>Upgrade</p>
        <div className={styles["team-settings-header-spacer"]} aria-hidden />
      </div>

      <div style={{ padding: "16px", flex: 1 }}>
        {showCodeInput ? (
          <LoginCodeInput
            email={emailForMagic}
            onCodeVerified={handleCodeVerified}
            onBack={handleBackToEmail}
            isLoading={isLoading}
            isOnline={isOnline}
            fullPage={false}
          />
        ) : (
          <>
            <div className="JoinWithCode-header">
              <h4 className="JoinWithCode-title" style={{ fontSize: "18px" }}>
                Visit{" "}
                <a href={SUBSCRIPTION_SITE} target="_blank" rel="noreferrer">
                  experienceapp.io
                </a>{" "}
                to buy a subscription
              </h4>
            </div>

            <p style={{ color: "#555", marginBottom: "16px", lineHeight: 1.5 }}>
              Log in with the email you use (or will use) for your account, then
              open the link above to complete your purchase.
            </p>

            {error ? (
              <div
                className="JoinWithCode-error"
                style={{ marginBottom: "12px" }}
              >
                {error}
              </div>
            ) : null}
            {successMessage ? (
              <div
                style={{
                  backgroundColor: "#efe",
                  color: "#3c3",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  marginBottom: "16px",
                  fontSize: "14px",
                }}
              >
                {successMessage}
              </div>
            ) : null}

            {loadingStates?.users ? (
              <p style={{ color: "#666", marginBottom: "16px" }}>
                Loading user data...
              </p>
            ) : (
              <>
                <input
                  type="email"
                  autoComplete="email"
                  className="JoinWithCode-input"
                  value={emailForMagic}
                  onChange={(e) => {
                    setEmailForMagic(e.target.value);
                  }}
                  placeholder="Email"
                />

                <button
                  type="button"
                  className="proceed-button"
                  onClick={() => void sendMagicLink()}
                  disabled={!emailForMagic.trim() || isLoading}
                >
                  {isLoading ? "Sending..." : "Log in"}
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TeamDemoUpgrade;
